import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { debounceTime } from 'rxjs/operators'
import { FormControl } from '@angular/forms'
import { SearchTruncated } from 'src/app/_helpers/SearchTruncated'
import * as moment_ from 'moment'
import { isValidInt4 } from 'src/app/_helpers/Utils'
import { NotificationService } from 'src/app/services/notification.service'

@Component({
	selector: 'app-input-search-component',
	templateUrl: './input-search.component.html'
})
export class InputSearch implements OnDestroy {

	@Input() public valuesSearchTruncated: Array<SearchTruncated> = []
	@Input() public enableSearchTruncated: boolean = false
	@Input() public enableFiltersForCommunications: boolean = false
	@Input() public enableCategoryRisk: boolean = false
	@Input() public enableCategoryAddress: boolean = false
	@Input() public enableTreeNotFound: boolean = false

	@Output() public valueChange = new EventEmitter<string>()
	@Output() public valueSearchTruncated = new EventEmitter<string>()

	public inputControl = new FormControl()
	public handleValuesSearchTruncater: Array<SearchTruncated> = []
	public openSearchTruncated: boolean = false
	public openCancelSearchModal: boolean = false
	public handleOnlyNotAssign: boolean = false
	public onlyNotAssign: boolean = false
	public handleOnlyAssign: boolean = false
	public onlyAssign: boolean = false
	public handleOnlyDone: boolean = false
	public onlyDone: boolean = false
	public handleOnlyNotDone: boolean = false
	public onlyNotDone: boolean = false
	public categoryRisk: 'NENHUM' | 'BAIXO' | 'MODERADA' | 'ALTO' | 'MUITO_ALTO' = 'NENHUM'
	public handleCategoryRisk: 'NENHUM' | 'BAIXO' | 'MODERADA' | 'ALTO' | 'MUITO_ALTO' = 'NENHUM'
	public categoryAddress: '0' | '1' | '2' | '3' | '4' = '0'
	public handleCategoryAddress: '0' | '1' | '2' | '3' | '4' = '0'

	public handleAv3WithDocument: boolean = false
	public av3WithDocument: boolean = false
	public handleAv3WithoutDocument: boolean = false
	public av3WithoutDocument: boolean = false
	public onlyNotRequester: boolean = false
	public handleOnlyNotRequester: boolean = false
	public treeNotFound: boolean = false
	public handleTreeNotFound: boolean = false


	constructor(
		public notificationService: NotificationService
	) {
		this.inputControl.valueChanges.pipe(
			debounceTime(400)
		).subscribe(value => {
			const isNumber = !isNaN(value) && Boolean(value)

			if (isNumber) {
				if (!isValidInt4(value)) {
					this.notificationService.notify('Valor de busca inválido!', 500)
					return
				}
			}

			this.valueChange.emit(this.encodedString(value))
		})
	}

	public emptyValueSearch(): boolean {
		const emptyValues = this.handleValuesSearchTruncater.every(value => value.value === '')

		return emptyValues &&
			   !this.handleOnlyNotAssign &&
			   !this.handleOnlyAssign &&
			   !this.handleOnlyNotDone &&
			   !this.handleOnlyDone &&
			   !this.handleAv3WithDocument &&
			   !this.handleAv3WithoutDocument &&
			   !this.handleOnlyNotRequester &&
			   !this.handleTreeNotFound &&
			   !Boolean(this.handleCategoryRisk !== 'NENHUM') &&
			   !Boolean(this.handleCategoryAddress !== '0')
	}

	public openCloseSearchTruncated(open: boolean) {

		if (!open) {
			const noChanges: boolean =
				this.equalityTest(this.valuesSearchTruncated, this.handleValuesSearchTruncater)

			if (!noChanges) {
				this.openCloseCancelModal()
				return
			}
		}

		this.handleValuesSearchTruncater = this.deepCopy(this.valuesSearchTruncated)
		this.handleOnlyNotAssign = this.onlyNotAssign
		this.handleOnlyAssign = this.onlyAssign
		this.handleOnlyNotDone = this.onlyNotDone
		this.handleOnlyDone = this.onlyDone
		this.handleAv3WithDocument = this.av3WithDocument
		this.handleAv3WithoutDocument = this.av3WithoutDocument
		this.handleOnlyNotRequester = this.onlyNotRequester
		this.handleCategoryRisk = this.categoryRisk
		this.handleCategoryAddress = this.categoryAddress
		this.handleTreeNotFound = this.treeNotFound
		this.openSearchTruncated = open
	}

	public closeSearchTruncated() {
		this.openCancelSearchModal = false
		this.openSearchTruncated = false
	}

	public openCloseCancelModal() {
		this.openCancelSearchModal = !this.openCancelSearchModal
	}

	public createStringSearchTruncate(): string {
		let stringSearchFormated: string = ''

		this.handleValuesSearchTruncater.forEach(value => {
			if (value.value) {

				let valueToSearch: string = ''

				// Se o atributo dor do tipo data, acrescenta um dia para que a API possa realizar a busca corretamente
				if (value.type == 'date') {

					valueToSearch = moment_(`${value.value} 12:00:00`).format('YYYY-MM-DD')

				} else {

					valueToSearch = value.value

				}

				stringSearchFormated += this.encodedString(`&${value.key}=${valueToSearch}`)
			}
		})

		if (
			stringSearchFormated ||
			this.handleCategoryRisk !== 'NENHUM' ||
			this.handleCategoryAddress !== '0'
		) {
			stringSearchFormated += '&truncate=true'
		}

		if (this.handleOnlyNotAssign) {
			stringSearchFormated += '&onlyNotAssign=true'
		}
		if (this.handleOnlyAssign) {
			stringSearchFormated += '&onlyAssign=true'
		}
		if (this.handleOnlyNotDone) {
			stringSearchFormated += '&onlyNotDone=true'
		}
		if (this.handleOnlyDone) {
			stringSearchFormated += '&onlyDone=true'
		}
		if (this.handleAv3WithDocument) {
			stringSearchFormated += '&av3WithDocument=true'
		}
		if (this.handleAv3WithoutDocument) {
			stringSearchFormated += '&av3WithoutDocument=true'
		}
		if (this.handleOnlyNotRequester) {
			stringSearchFormated += '&onlyNotRequester=true'
		}
		if (this.handleTreeNotFound) {
			stringSearchFormated += '&treeNotFound=true'
		}
		if (this.handleCategoryRisk !== 'NENHUM') {
			stringSearchFormated += `&categoryRisk=${this.handleCategoryRisk}`
		}
		if (this.handleCategoryAddress !== '0') {
			stringSearchFormated += `&categoryAddress=${this.handleCategoryAddress}`
		}

		return stringSearchFormated
	}

	public clearItem(index: number) {
		if (this.handleValuesSearchTruncater[index].value != '') {
			this.handleValuesSearchTruncater[index].value = ''
		}
	}

	public clearAllItens() {
		this.handleValuesSearchTruncater.forEach(item => {
			item.value = ''
		})
		this.handleOnlyNotAssign = false
		this.handleOnlyAssign = false
		this.handleOnlyNotDone = false
		this.handleOnlyDone = false
		this.handleAv3WithDocument = false
		this.handleAv3WithoutDocument = false
		this.handleOnlyNotRequester = false
		this.handleTreeNotFound = false
		this.handleCategoryRisk = 'NENHUM'
		this.handleCategoryAddress = '0'

		const handleEqualsGlobalValues: boolean =
			this.equalityTest(this.valuesSearchTruncated, this.handleValuesSearchTruncater)

		if (handleEqualsGlobalValues) {
			return
		}

		this.valueSearchTruncated.emit('')
		this.valuesSearchTruncated = this.deepCopy(this.handleValuesSearchTruncater)
		this.onlyNotAssign = false
		this.onlyAssign = false
		this.onlyNotDone = false
		this.onlyDone = false
		this.av3WithDocument = false
		this.av3WithoutDocument = false
		this.onlyNotRequester = false
		this.treeNotFound = false
		this.categoryRisk = 'NENHUM'
		this.categoryAddress = '0'
	}

	public searchTruncated() {
		const stringSearchTruncatedFormated = this.createStringSearchTruncate()

		this.valueSearchTruncated.emit(stringSearchTruncatedFormated)
		this.valuesSearchTruncated = this.deepCopy(this.handleValuesSearchTruncater)
		this.onlyNotAssign = this.handleOnlyNotAssign
		this.onlyAssign = this.handleOnlyAssign
		this.onlyNotDone = this.handleOnlyNotDone
		this.onlyDone = this.handleOnlyDone
		this.av3WithDocument = this.handleAv3WithDocument
		this.av3WithoutDocument = this.handleAv3WithoutDocument
		this.onlyNotRequester = this.handleOnlyNotRequester
		this.treeNotFound = this.handleTreeNotFound
		this.categoryRisk = this.handleCategoryRisk
		this.categoryAddress = this.handleCategoryAddress

		this.openSearchTruncated = false
	}

	public deepCopy(obj: Array<SearchTruncated>): Array<SearchTruncated> {
		return JSON.parse(JSON.stringify(obj))
	}

	public equalityTest(obj1: Array<SearchTruncated>, obj2: Array<SearchTruncated>): boolean {
		const onlyNotAssign: boolean = this.onlyNotAssign === this.handleOnlyNotAssign
		const onlyAssign: boolean = this.onlyAssign === this.handleOnlyAssign
		const onlyNotDone: boolean = this.onlyNotDone === this.handleOnlyNotDone
		const onlyDone: boolean = this.onlyDone === this.handleOnlyDone
		const av3WithDocument: boolean = this.av3WithDocument === this.handleAv3WithDocument
		const av3WithoutDocument: boolean = this.av3WithoutDocument === this.handleAv3WithoutDocument
		const onlyNotRequester: boolean = this.onlyNotRequester === this.handleOnlyNotRequester
		const treeNotFound: boolean = this.treeNotFound === this.handleTreeNotFound
		const categoryRisk: boolean = this.categoryRisk === this.handleCategoryRisk
		const categoryAddress: boolean = this.categoryAddress === this.handleCategoryAddress

		return JSON.stringify(obj1) === JSON.stringify(obj2) &&
			onlyNotAssign &&
			onlyAssign &&
			onlyNotDone &&
			onlyDone &&
			av3WithDocument &&
			av3WithoutDocument &&
			onlyNotRequester &&
			treeNotFound &&
			categoryRisk &&
			categoryAddress
	}

	public switchFilterForCommunication(
		typeFilter: 'onlyNotAssign' |
					'onlyAssign' |
					'onlyNotDone' |
					'onlyDone' |
					'av3WithDocument' |
					'av3WithoutDocument' |
					'onlyNotRequester' |
					'treeNotFound' |
					'categoryRisk' |
					'categoryAddress'
	) {
		switch (typeFilter) {
			case 'onlyNotAssign':
				this.handleOnlyNotAssign = !this.handleOnlyNotAssign

				if (this.handleOnlyNotAssign) {
					this.handleOnlyAssign = false
					this.handleOnlyNotDone = false
					this.handleOnlyDone = false
				}
				break
			case 'onlyAssign':
				this.handleOnlyAssign = !this.handleOnlyAssign

				if (this.handleOnlyAssign) {
					this.handleOnlyNotAssign = false
				}
				break
			case 'onlyNotDone':
				this.handleOnlyNotDone = !this.handleOnlyNotDone

				if (this.handleOnlyNotDone) {
					this.handleOnlyNotAssign = false
					this.handleOnlyAssign = true
					this.handleOnlyDone = false
				}
				break
			case 'onlyDone':
				this.handleOnlyDone = !this.handleOnlyDone

				if (this.handleOnlyDone) {
					this.handleOnlyNotAssign = false
					this.handleOnlyAssign = true
					this.handleOnlyNotDone = false
				}
				break
			case 'av3WithDocument':
				this.handleAv3WithDocument = !this.handleAv3WithDocument

				if (this.handleAv3WithDocument) {
					this.handleAv3WithoutDocument = false
				}
				break
			case 'av3WithoutDocument':
				this.handleAv3WithoutDocument = !this.handleAv3WithoutDocument

				if (this.handleAv3WithoutDocument) {
					this.handleAv3WithDocument = false
				}
				break
			case 'onlyNotRequester':
				this.handleOnlyNotRequester = !this.handleOnlyNotRequester
				break
			case 'treeNotFound':
				this.handleTreeNotFound = !this.handleTreeNotFound
				break
			case 'categoryRisk':
				this.handleCategoryRisk = 'NENHUM'
				break
			case 'categoryAddress':
				this.handleCategoryAddress = '0'
				break
		}
	}

	public encodedString(value: string) {
		return value.replace(/#/g, '%23')
	}

	public ngOnDestroy(): void {
		this.valuesSearchTruncated.forEach(value => {
			value.value = ''
		})
	}
}
